import axios from "axios";
import { DATABASE_URL, STUDIO_API_TOKEN } from "../../constants";
import appMode from '../../services/appMode';

let _studioAxios = null;
let _studioAxiosToken = null;

function getStudioAxios() {
    // Prefer the token injected by the app via ?arkaToken= URL param,
    // fall back to the hardcoded service token for web/dev use.
    const token = appMode.getAuthToken() || STUDIO_API_TOKEN;

    if (_studioAxios && _studioAxiosToken === token) return _studioAxios;

    _studioAxiosToken = token;
    // Uses DATABASE_URL as the base for all requests.
    // In the ArkaGo WebView, the native XHR bridge intercepts and forwards requests.
    const baseURL = DATABASE_URL;
    _studioAxios = axios.create({
        baseURL,
        headers: {
            'accept': 'application/json, text/plain, */*',
            'content-type': 'application/json',
            'authorization': token.startsWith('Token ') ? token : `Token ${token}`,
        }
    });

    return _studioAxios;
}

export default{
    CREATE_LEAD(postData) {
        return axios.post(`/api/lead/`, postData);
    },
    PATCH_LEAD(id, postData) {
        return axios.patch(`/api/lead/${id}/`, postData);
    },
    GET_FINANCIAL_DATA(id, postData) {
        return axios.post(`/api/lead/${id}/financial_data/`, postData);
    },
    SEND_EMAIL(postData){
        return axios.post(`/lead/send_email`,postData);
    },
    FETCH_STUDIO_REPORT_INFO(lead_id){
        return axios.get(`/api/solar-report/?query=new&lead=${lead_id}`);
    },
    
    // Studio Design API endpoints
    STUDIO_DESIGN: {
        // Save design (create new or update existing)
        async SAVE_DESIGN(designId, designData) {
            try {
                const response = await getStudioAxios()({
                    method: designId === 'new' ? 'POST' : 'PATCH',
                    url: designId === 'new' 
                        ? `/api/mobile-app/contacts/studio_design/`
                        : `/api/mobile-app/contacts/${designId}/studio_design/`,
                    data: {
                        studio_design: designData
                    }
                });

                return response;
            } catch (error) {
                console.error('[StudioAPI] SAVE_DESIGN error:', error.message);
                throw error;
            }
        },
        
        // Load design by ID
        async LOAD_DESIGN(designId) {
            try {
                const response = await getStudioAxios()({
                    method: 'GET',
                    url: `/api/mobile-app/contacts/${designId}/studio_design/`
                });

                return response;
            } catch (error) {
                console.error('[StudioAPI] LOAD_DESIGN error:', error.message);
                throw error;
            }
        }
    },
    
    // Financial Data API endpoints (for design_details and input_details)
    FINANCIAL_DATA: {
        // Save design and input details to backend
        async SAVE(contactId, designDetails, inputDetails) {
            try {
                const payload = {};
                if (designDetails) payload.design_details = designDetails;
                if (inputDetails) payload.input_details = inputDetails;

                const response = await getStudioAxios()({
                    method: 'PATCH',
                    url: `/api/mobile-app/contacts/${contactId}/financial_data/`,
                    data: payload
                });

                // Handle both {data:{...}} wrapper and direct contact object formats
                const contactData = response.data?.data ?? response.data;
                if (!contactData) throw new Error('API response missing data field');

                return { ...response, data: contactData };
            } catch (error) {
                console.error('[StudioAPI] FINANCIAL_DATA.SAVE error:', error.message, error.response?.status);
                throw error;
            }
        },
        
        // Load design and input details by contact ID
        async LOAD(contactId) {
            try {
                const response = await getStudioAxios()({
                    method: 'GET',
                    url: `/api/mobile-app/contacts/${contactId}/financial_data/`
                });

                // Handle both {data:{...}} wrapper and direct contact object formats
                const contactData = response.data?.data ?? response.data;
                if (!contactData) throw new Error('API response missing data field');

                return { ...response, data: contactData };
            } catch (error) {
                console.error('[StudioAPI] FINANCIAL_DATA.LOAD error:', error.message, error.response?.status);
                throw error;
            }
        }
    }
}